export function toDatabaseName(value: string) {
  return value.replace(/[^A-Z0-9]+/gi, '').toLowerCase()
}
